import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformMetrics = ({ metrics }) => {
  const metricCards = [
    {
      title: 'Total Active Gyms',
      value: metrics?.totalActiveGyms,
      icon: 'Building2',
      color: 'var(--color-primary)',
      suffix: '',
      trend: '+3 this month'
    },
    {
      title: 'Total Platform Users',
      value: metrics?.totalUsers?.toLocaleString(),
      icon: 'Users',
      color: 'var(--color-accent)',
      suffix: '',
      trend: '+847 this month'
    },
    {
      title: 'SaaS Subscription Revenue',
      value: `$${(metrics?.subscriptionRevenue / 1000)?.toFixed(1)}K`,
      icon: 'DollarSign',
      color: 'var(--color-success)',
      suffix: '/month',
      trend: '+5.2% MoM'
    },
    {
      title: 'System Uptime',
      value: `${metrics?.systemUptime}%`,
      icon: 'Activity',
      color: 'var(--color-info)',
      suffix: '',
      trend: '99.9% SLA target'
    },
    {
      title: 'Active Subscriptions',
      value: metrics?.activeSubscriptions,
      icon: 'CreditCard',
      color: 'var(--color-warning)',
      suffix: '',
      trend: '+5 new this month'
    },
    {
      title: 'Churn Rate',
      value: `${metrics?.churnRate}%`,
      icon: 'TrendingDown',
      color: 'var(--color-error)',
      suffix: '',
      trend: '-0.8% vs last month'
    },
    {
      title: 'Avg Revenue Per Gym',
      value: `$${(metrics?.avgRevenuePerGym / 1000)?.toFixed(1)}K`,
      icon: 'BarChart3',
      color: 'var(--color-primary)',
      suffix: '/month',
      trend: '+12% YoY'
    },
    {
      title: 'Support Tickets',
      value: metrics?.supportTickets,
      icon: 'AlertCircle',
      color: 'var(--color-warning)',
      suffix: '',
      trend: '18 resolved today'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metricCards?.map((metric, index) => (
        <div key={index} className="card hover:shadow-xl transition-all duration-250">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-2">{metric?.title}</p>
              <h3 className="text-3xl font-heading font-semibold text-foreground">
                {metric?.value}
                {metric?.suffix && (
                  <span className="text-sm text-muted-foreground ml-1">{metric?.suffix}</span>
                )}
              </h3>
            </div>
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center"
              style={{ backgroundColor: `${metric?.color}15` }}
            >
              <Icon name={metric?.icon} size={24} color={metric?.color} />
            </div>
          </div>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Icon name="Info" size={12} />
            <span>{metric?.trend}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlatformMetrics;